const toCamelCase = (str: string) => {
  return str.replace(/_([a-z0-9])/g, (g) => g[1].toUpperCase());
};

export const deepCamelCaseKeys = (obj: any): any => {
  if (Array.isArray(obj)) {
    return obj.map((v) => deepCamelCaseKeys(v));
  } else if (obj !== null && obj !== undefined && obj.constructor === Object) {
    return Object.keys(obj).reduce((result, key) => {
      result[toCamelCase(key)] = deepCamelCaseKeys(obj[key]);
      return result;
    }, {} as any);
  }
  return obj;
};
